import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const MessageDigestMD5Module = () => (
  <QPhototModuleSubtopic
    title="Message Digest (MD5)"
    videos={[
      "https://www.youtube.com/embed/53O9J2J5i14"
    ]}
    takeaways={[
      {
        text:
          "Avoid short 10-minute YouTube videos for MD5 that do not cover the full topic in depth."
      },
      {
        text:
          "Remember and practice the F, G, H, and I function formulas; solve at least one problem manually and using a calculator."
      },
      {
        text:
          "If MD5 is part of CAT-2, carefully copy full class notes and at least one worked example into your notebook to make exam problem solving easier."
      }
    ]}
    questions={[
      {
        text:
          "Compute the value of the padding field, length field, and number of blocks in MD5 if the length of the message is 4000 bits."
      },
      {
        text:
          "Find the output of the logical functions F, G, H, and I used in MD5 round operations if the initial value of the buffers are as follows: A = 01234567, B = 89abcdef, C = fedcba98, D = 76543210."
      },
      {
        text:
          "A financial institution is implementing MD5 hashing to ensure the integrity of transaction messages. As part of a security audit, analysts are required to examine how MD5 processes a given transaction message. Given that the message is processed into 1009 blocks, and the padding size (excluding the length field) is 43 bytes, determine the following:\n(a) Calculate the total size of the padded message in bits.\n(b) Determine the original message size before padding was added.\n(c) How are the logical functions applied to the leftmost digits of the following buffers in each round operation? Given: B = 0xDEE0, C = 0x7792, D = 0xA8CC."
      },
      {
        text:
          "Why do some cryptographic algorithms, such as RSA, ECC, AES, and SHA-512, remain successful, while others, like MD5 and DES, have failed? Analyse the factors that contribute to the longevity or downfall of cryptosystems, including security strength, computational efficiency, and resistance to attacks."
      }
    ]}
    exampleVideos={[]}
  />
);

export default MessageDigestMD5Module;
